import styled, { keyframes } from 'styled-components';
import { StyledGradientBg } from '../commons/commons.styles';

const scroll = keyframes`
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-50%);
  }
`;

export const StyledCTASection = styled.section`
  position: relative; 
  margin: 0 0 18.7rem;
  ${StyledGradientBg};
  &::before {
    top: 20%;

    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      display: none;
    }
  }
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 5rem;
  }
`;

export const StyledContentWrapperOuter = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  border-radius: 1rem;
  padding: 0.25rem;
  background: linear-gradient(91deg, rgba(82, 123, 211, 1) 0%, rgba(158, 179, 225, 1) 58%, rgba(167, 231, 255, 1) 100%);
  z-index: 2;
`;

export const StyledContentWrapper = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.secondary.light};
  padding: 7rem 6rem 5rem;
  border-radius: 0.8rem;
  width: 100%;
  z-index: 2;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 5rem 4rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 4rem 2.4rem;
    gap: 3.2rem;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
 
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 4rem;
  }

`;

export const StyledHeading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2rem;
  line-height: 1.257;
  text-align: center;
  color: transparent;
  background: linear-gradient(91deg, rgba(82, 123, 211, 1) 0%, rgba(158, 179, 225, 1) 58%, rgba(167, 231, 255, 1) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  margin: 0;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 1.8rem;
  }
`;

export const StyledSubheading = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 4.4rem;
  line-height: 1.257;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  margin: 2.4rem 0 3.2rem;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    br {
      display: none;
    }
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 3.2rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    font-size: 2.8rem;

  }
`;

export const StyledDescription = styled.p`
  font-size: 2rem;
  line-height: 1.3;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey[400]};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  max-width: 59.8rem;
  margin: 0 0 6rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 1.8rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    font-size: 1.6rem;
  }
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2.4rem;

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    flex-direction: column;
    width: 100%;
    gap: 1.2rem;
  }
`;

export const StyledButton = styled.button<{ variant: 'primary' | 'secondary' }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 1rem;
  height: 4.1rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 1.8rem;
  line-height: 1.149;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  border-radius: 0.4rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: 17.9rem;

  ${({ variant, theme }) =>
    variant === 'primary'
      ? `
    background: ${theme.colors.primary.main};
    color: ${theme.colors.text.invert};
    border: 0.1rem solid ${theme.colors.primary.main};

    &:hover {
      background: ${theme.colors.primary.dark || theme.colors.primary.main};
      transform: translateY(-0.1rem);
      box-shadow: 0 0.4rem 1.2rem rgba(163, 234, 42, 0.3);
    }
  `
      : `
    background: transparent;
    color: ${theme.colors.text.main};
    border: 0.1rem solid ${theme.colors.primary.main};

    &:hover {
      background: rgba(163, 234, 42, 0.1);
      transform: translateY(-0.1rem);
    }
  `}

  @media (max-width: ${({ theme }) => theme.sizes.sm}) {
    width: 100%;
    padding: 1.2rem 2.4rem;
    font-size: 1.6rem;
  }
`;

export const StyledLogoContainer = styled.div`
  position: relative;
  width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  height: 5rem;
  margin-top: 7.5rem;

  &::before,
  &::after {
      width: 15rem;
      height: 4rem;
    }
  /* Fading effect on the left */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(to right, ${({ theme }) => theme.colors.secondary.light}, transparent);
    z-index: 2;
    pointer-events: none;
  }

  /* Fading effect on the right */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(to left, ${({ theme }) => theme.colors.secondary.light}, transparent);
    z-index: 2;
    pointer-events: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    &::before,
    &::after {
      width: 8rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    height: 6rem;
    margin-top: 5rem;
  }
`;

export const StyledLogoTrack = styled.div`
  display: flex;
  gap: 9rem;
  animation: ${scroll} 50s linear infinite;
  width: fit-content;
  align-items: center;

  /* Pause animation on hover */
  &:hover {
    animation-play-state: paused;

    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      animation-play-state: running;
    }
  }

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 6rem;
    animation-duration: 40s;
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 4rem;
    animation-duration: 30s;
  }
`;

export const StyledCompanyImage = styled.img`
  max-height: 3.8rem;
  object-fit: contain;
  align-self: center;
  flex-shrink: 0;
  min-width: 15rem;
  opacity: 0.8;

  &[alt='ThreatLocker'] {
    height: 1.9rem
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: 2.3rem;
    min-width: 10rem;

    &[alt='ThreatLocker'] {
      height: 1.6rem
    }
  }
`;
